import primaryComponents from "../../../../primaryComponents";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import styles from "./styles.module.scss";
import { useGetCustomers } from "../../../../../hooks/api/queries";
import secondaryComponents from "../../..";
import { useState } from "react";
import { PlusIcon } from "../../../../../assets/svgIcons";
import { RoutedModal } from "../../../../common";
import { CustomerForm } from "../../../customers";

export const ContactList = ({ formData, setFormData = () => {} }) => {
  const [queryParams, setQueryParams] = useState({
    page: 1,
    query: "",
  });
  const [isAddCustomer, setIsAddCustomer] = useState(false);
  const { isLoading, data } = useGetCustomers({ queryParams });
  const customers = data?.data;
  const metaDetails = data?.meta;

  const gotoPage = (val) => {
    setQueryParams((prev) => ({ ...prev, page: val }));
  };

  return (
    <>
      <div
        className={` ${globalStyles["cardWithBackground"]} white`}
        style={{ gap: "15px" }}
      >
        <div className="d-flex" style={{ gap: "10px" }}>
          <primaryComponents.SearchField
            classNames="w-100"
            value={queryParams?.query}
            placeholder="Search by name, email or phone number"
            trigger={(val) =>
              setQueryParams((prev) => ({ ...prev, query: val }))
            }
          />
          <primaryComponents.Button
            classNames={"btn btn--outline"}
            onClick={() => setIsAddCustomer(true)}
          >
            <PlusIcon className="mr-1" />
            New
          </primaryComponents.Button>
        </div>

        <div>
          <div className="pb-2">
            <primaryComponents.Checkbox
              className="ml-auto"
              name="smsAudienceSelectAll"
              id={"smsAudienceSelectAll"}
              isChecked={formData?.select_all_customers}
              onChange={() =>
                setFormData((prev) => ({
                  ...prev,
                  select_all_customers: !formData?.select_all_customers,
                  customer_ids: [],
                  exclude_customer_ids: [],
                  total_customers: metaDetails?.total,
                }))
              }
            >
              <span className="d-block mt-1">Select All</span>
            </primaryComponents.Checkbox>
          </div>

          <div
            className={`${globalStyles["cardWithBorder"]} ${styles.contact} p-0`}
          >
            <secondaryComponents.LoaderHelper
              isLoading={isLoading}
              classNames={"my-5"}
            >
              {customers?.map((customer) => (
                <label
                  key={customer?.id}
                  htmlFor={`smsAudience${customer?.id}`}
                  className={styles.contact__card}
                >
                  <div className="d-flex" style={{ gap: "10px" }}>
                    <primaryComponents.Checkbox
                      name="smsAudience"
                      id={`smsAudience${customer?.id}`}
                      isChecked={
                        formData?.customer_ids?.includes(customer?.id) ||
                        (formData?.select_all_customers &&
                          !formData?.exclude_customer_ids?.includes(
                            customer?.id,
                          ))
                      }
                      onChange={() => {
                        if (!formData?.select_all_customers)
                          return setFormData((prev) => {
                            const exists = prev.customer_ids.includes(
                              customer.id,
                            );

                            return {
                              ...prev,
                              customer_ids: exists
                                ? prev.customer_ids.filter(
                                    (id) => id !== customer.id,
                                  )
                                : [...prev.customer_ids, customer.id],
                            };
                          });

                        setFormData((prev) => {
                          const exists = prev.exclude_customer_ids.includes(
                            customer.id,
                          );

                          return {
                            ...prev,
                            exclude_customer_ids: exists
                              ? prev.exclude_customer_ids.filter(
                                  (id) => id !== customer.id,
                                )
                              : [...prev.exclude_customer_ids, customer.id],
                          };
                        });
                      }}
                    />
                    <div>
                      <h6>{customer?.full_name}</h6>
                      <p className="small-text-size">
                        {customer?.email || "N/A"}
                      </p>
                    </div>
                  </div>

                  <div>
                    <p className="small-text-size">
                      +{customer?.phone_code} {customer?.phone}
                    </p>
                  </div>
                </label>
              ))}
            </secondaryComponents.LoaderHelper>
          </div>
        </div>

        <secondaryComponents.Pagination
          totalPageNumber={metaDetails?.last_page}
          handlePageClick={(value) => gotoPage(value?.selected + 1)}
          currentPage={metaDetails?.current_page}
        />
      </div>

      <RoutedModal
        isActive={isAddCustomer}
        width={800}
        headerTitle="Add New Customer"
        closeModal={() => {
          setIsAddCustomer(false);
        }}
        style={{ height: "auto" }}
      >
        <CustomerForm
          closeModal={() => {
            setIsAddCustomer(false);
          }}
        />
      </RoutedModal>
    </>
  );
};
